import { useCallback } from 'react'
import { CreditType, useReservationUpdateMutation } from 'src/api/api.generated'
import { useTenant } from 'src/app/hooks/context/context.hook'
import syncMutation from 'src/utils/sync-mutation'
import { ReservationUpdateResult } from '../types/reservation-detail.types'

export default function useUpdateReservationCredit() {
  const tenantId = useTenant().id
  const [updateReservationMutation, { loading }] = useReservationUpdateMutation()

  const updateCreditType = useCallback(
    async (reservationId: string, credit: CreditType): Promise<ReservationUpdateResult> => {
      const result = await syncMutation(updateReservationMutation, {
        variables: {
          id: reservationId,
          input: {
            tenantId: tenantId,
            credit: credit,
          },
        },
        refetchQueries: ['ReservationDetail', 'ReservationSearch'],
        awaitRefetchQueries: true,
      })
      const reservation = result.result?.data?.updateReservation
      if (reservation) {
        return { type: 'SUCCESS', reservation }
      }
      return { type: 'FAIL', errors: result.error }
    },
    [tenantId],
  )

  return { updateCreditType, loading }
}
